import { Route } from "react-router-dom";
import UnAuthGuard from "../guards/UnAuthGuard";
import { Login } from "../../features/AuthenticateView/pages/Login/Login";
import { LOGIN_ROUTE_KEY } from "../../shared/utils/CommonConstants";

const UnAuthRoutes = [
  <Route
    key={LOGIN_ROUTE_KEY}
    path="/login"
    element={<UnAuthGuard component={<Login />} />}
  />,
  <Route
    key={LOGIN_ROUTE_KEY}
    path="/"
    element={<UnAuthGuard component={<Login />} />}
  />,
];

export default UnAuthRoutes;
